<div [innerHTML]="textDirection == 'rtl' ? sanitizerContent(content?.contentEn) : sanitizerContent(content?.contentAr)"></div>